import { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import '../../../components/uploadFile/upload.css'
// import '../css/AlertDialogFreight.css'
import { MdCloudUpload, MdDelete } from 'react-icons/md';
import { Box, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';

/**
 * AlertDialog - Componente de diálogo para importar documentos
 * 
 * @param {function} handleClose - Função para fechar o diálogo
 * @param {boolean} open - Estado do diálogo (aberto ou fechado)
 * @param {function} handleUpload - Função para realizar o upload do arquivo
 * @param {string} operationType - Tipo de operação (ex.: "carga", "descarga")
 * 
 * @returns {JSX.Element} - Elemento JSX do diálogo
 */
export default function AlertDialog({ handleClose, open, origem, handleUpload, operationType }) {

    const [files, setFiles] = useState([]);
    const [filePreviews, setFilePreviews] = useState([]);
    const [uploading, setUploading] = useState(false);


    const handleFileChange = ({ target: { files: selectedFiles } }) => {
        if (selectedFiles && selectedFiles.length > 0) {

            const newFiles = Array.from(selectedFiles);


            setFiles(prevFiles => [...prevFiles, ...newFiles]);

            // Cria URLs de pré-visualização para os novos arquivos
            const newPreviews = newFiles.map(file => ({
                url: URL.createObjectURL(file),
                name: 'Documentação-' + file.name,
                type: file.type
            }));
            setFilePreviews(prevPreviews => [...prevPreviews, ...newPreviews]);
        }
    };


    const handleRemoveFile = (indexToRemove) => {
        setFiles(files.filter((_, index) => index !== indexToRemove));
        setFilePreviews(filePreviews.filter((_, index) => index !== indexToRemove));
    };


    const handleUploadClick = async () => {
        if (files.length === 0) return;

        setUploading(true);
        try {
            // Faz o upload de cada arquivo da lista, um de cada vez
            for (const fileToUpload of files) {
                await handleUpload(fileToUpload);    
            }
            // Após o sucesso de todos os uploads, limpa a lista
            cleanupState();
            // Mantém o modal aberto para uma nova seleção
        } catch (error) {
            console.log("Erro durante o upload de um dos arquivos:", error);
            // Mesmo com erro, o estado de upload é finalizado
            setUploading(false);
        } finally {
            setUploading(false);
        }
    };


    
    const getAllowedFileTypes = () => {
        if (operationType === 'carga') {
            
            return 'image/*,application/pdf'; // Carga: Imagens e PDF
        } else if (operationType === 'descarga') {
          
            return 'image/*'; // Descarga: Apenas Imagens
        }
        return 'image/*,application/pdf'; // Padrão/Fallback: Imagens e PDF
    };

    // Função para limpar o estado
    const cleanupState = () => {
        setFiles([]);
        setFilePreviews([]);
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={() => {
                    cleanupState();
                    handleClose();
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Importar documento(s) do " + operationType}
                </DialogTitle>
                <DialogContent>
                    <main>

                        <form
                            className="upload-form"
                            onClick={() => document.querySelector(".input-field").click()}
                        >
                            <input
                                type="file"
                                // accept="image/*,application/pdf"
                                accept={getAllowedFileTypes()}
                                className="input-field"
                                hidden
                                // multiple
                                onChange={handleFileChange}
                            />

                            {filePreviews.length === 0 ? (
                                <>
                                    <h4
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px",
                                        }}
                                        className="mt-3 ml-12 mb-3"
                                    >
                                        <MdCloudUpload color="#1475cf" size={60} />
                                        <p>Clique ou arraste arquivos aqui</p>

                                    </h4>
                                </>
                            ) : (
                                // ALTERAÇÃO 6: Exibe a lista de arquivos para pré-visualização
                                <Box sx={{ width: '100%', maxHeight: 300, overflowY: 'auto' }}>
                                    <List>
                                        {filePreviews.map((file, index) => (
                                            <ListItem
                                                key={index}
                                                secondaryAction={
                                                    <IconButton edge="end" aria-label="delete" onClick={(e) => { e.stopPropagation(); handleRemoveFile(index); }}>
                                                        <MdDelete color='red' />
                                                    </IconButton>
                                                }
                                            >
                                                <ListItemText primary={file.name} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            )}
                        </form>
                    </main>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleUploadClick}
                        disabled={files.length === 0 || uploading}
                        variant="contained"
                    >
                        {uploading ? `Importando ${files.length} arquivos...` : `Importar ${files.length} arquivos`}
                    </Button>
                    <Button
                        onClick={() => {
                            cleanupState();
                            handleClose();
                        }}
                        color="error"
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}